if (document.getElementById('rule-modal') !== null) {
    var ruleModal = new bootstrap.Modal('#rule-modal', {})
    ruleModal.show()
}

$('[data-scroll_down_target]').each(function () {
    var $scroll = $(this);
    var $targetId = ($scroll.data('scroll_down_target') || '').replace(/^#/, '');
    var $target = $scroll.closest('.rule-modal').find('[id^='+$targetId+']');

    function handleCheckboxVisibility() {
        if($scroll.is(':visible')) {
            if ($scroll[0].scrollHeight > $scroll[0].clientHeight) {
                $scroll.scroll(function () {
                    var enable = $scroll[0].scrollHeight > 0
                        && $scroll[0].scrollHeight <= $scroll.scrollTop() + $scroll.innerHeight() + 50
                    if (enable) {
                        setTimeout(function () {
                            $target.attr('disabled', null)
                        }, 300);
                    }
                }).scroll();
            } else {
                $target.attr('disabled', null)
            }
        }
    }

    function createObserver() {
        let observer = new IntersectionObserver(handleCheckboxVisibility, {
            root: null
        });
        observer.observe($scroll[0]);
    }

    if(!$scroll.is(':visible')){
        createObserver();
    }else{
        handleCheckboxVisibility()
    }
});